import React, { CSSProperties, ReactNode } from 'react'

const Section = ({ children, className, style, ...props }: { children: ReactNode, style?: CSSProperties, className?: string }) => {
  return (
    <section {...props} style={style} className={`px-8 py-8 md:py-16 max-w-screen-2xl mx-auto w-full ${className}`} >{children}</section>
  )
}

export default Section